import { gsap } from '../lib/gsap';

const initHero = (element) => {
    const tagline = document.querySelector('.js-tagline');

    const heroTl = gsap.timeline({
        defaults: {
            ease: 'power1.out'
        },
        scrollTrigger: {
            trigger: element,
            start: () => 'bottom bottom-=10',
            end: () => 'bottom top+=10',
            scrub: 0.75,
            fastScrollEnd: true,
            invalidateOnRefresh: true
        }
    });

    heroTl.to(tagline, {
        y: '-4vw',
        zIndex: 2
    }).to(tagline, {
        y: '5rem',
        bottom: 'auto',
        fontVariationSettings: '"wdth" 90',
        delay: 0.25
    });
}

export { initHero as default };
